import React, { useState } from 'react';
import FileInput from '../../../../Components/FIleInput';
import { uploadVideo } from '../../../../api/video-library';
import { voidOfSpecialCharacters } from '../../../../utilities/helpers';

//mui imports====
import useStyles from '../../styles';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { LoadingButton } from '@mui/lab';

import CheckBoxInput from '../../../../Components/CheckBoxInput';

//===============

const UploadMultipleVideos = ({ categories, videoUploadsOngoing, setVideoUploadsOngoing }) => {
	const classes = useStyles();

	const [baseData, setBaseData] = useState({
		baseFileName: '',
		baseTitle: '',
		baseCategory: '',
		baseSubCategory: '',
		description: '',
		files: [],
		uploadMuted: false
	});

	const handleUploadVideos = async () => {
		const {
			baseFileName,
			baseTitle,
			baseCategory,
			baseSubCategory,
			description,
			files,
			uploadMuted
		} = baseData;

		if (!baseTitle || !baseCategory || files.length === 0) {
			alert('fill all data');
			return;
		}
		if (!new RegExp('.mp4$').test(baseFileName)) {
			alert('File must be of type .mp4');
			return;
		}
		if (!voidOfSpecialCharacters(baseFileName)) {
			alert('Special characters in file names are not allowed!');
			return;
		}

		try {
			setVideoUploadsOngoing(true);

			for (let id = 0; id < files.length; id++) {
				const file = files[id];
				const videoDocData = new FormData();
				const fileName = `${baseFileName.split('.')[0]}${id + 1}.mp4`;
				videoDocData.append('video', file, fileName);
				videoDocData.append('fileName', fileName);
				videoDocData.append('title', `${baseTitle}${id + 1}`);
				videoDocData.append('category', baseCategory);
				videoDocData.append('subCategory', baseSubCategory);
				videoDocData.append('description', description);
				videoDocData.append('uploadMuted', uploadMuted);

				for (var key of videoDocData.entries()) {
					console.log(key[0] + ', ' + key[1]);
				}

				await uploadVideo(videoDocData);
				if (id === files.length - 1) alert('All videos uploaded successfully');
			}

			setVideoUploadsOngoing(false);
		} catch (err) {
			console.log(err);

			setVideoUploadsOngoing(false);
		}
	};

	return (
		<>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Typography color="primary" fontWeight="bold">
						NOTE : Since the video files naming will start from 1 please make sure that the videos
						are not already present, else it would override the current videos. Eg, if its demo.mp4
						and 2 files are uploaded, the files will be of following names demo1.mp4 and demo2.mp4
					</Typography>
				</Grid>
				<Grid item xs={6} className={classes.modalContentItem} style={{ position: 'relative' }}>
					<Typography className={classes.heading} fontWeight={600} variant="h6">
						Base File Name
					</Typography>

					<TextField
						id="outlined-size-normal"
						style={{ width: '100%' }}
						value={baseData.baseFileName}
						onChange={(e) => {
							setBaseData({ ...baseData, baseFileName: e.target.value });
						}}
					/>
				</Grid>
				<Grid item xs={6} className={classes.modalContentItem}>
					<Typography className={classes.heading} fontWeight={600} variant="h6">
						Base Title
					</Typography>
					<TextField
						id="outlined-size-normal"
						style={{ width: '100%' }}
						value={baseData.baseTitle}
						onChange={(e) => {
							setBaseData({ ...baseData, baseTitle: e.target.value });
						}}
					/>
				</Grid>
				<Grid item xs={6} className={classes.modalContentItem}>
					<Typography className={classes.heading} fontWeight={600} variant="h6">
						Category
					</Typography>
					<Select
						labelId="label"
						id="select"
						value={baseData.baseCategory}
						style={{ width: '100%' }}
						onChange={(e) => {
							setBaseData((data) => ({ ...data, baseSubCategory: '' }));
							setBaseData((data) => ({ ...data, baseCategory: e.target.value }));
						}}
					>
						{typeof categories === 'object' &&
							Object.keys(categories).map((category) => {
								if (category === 'dateCreated') return null;
								return (
									<MenuItem key={category} value={category}>
										{category}
									</MenuItem>
								);
							})}
					</Select>
				</Grid>
				<Grid item xs={6} className={classes.modalContentItem}>
					<Typography className={classes.heading} fontWeight={600} variant="h6">
						Sub Category
					</Typography>
					<Select
						labelId="sub-category"
						id="sub-category"
						value={baseData.baseSubCategory}
						style={{ width: '100%' }}
						onChange={(e) => {
							setBaseData((data) => ({ ...data, baseSubCategory: e.target.value }));
						}}
					>
						{baseData.baseCategory &&
							Array.isArray(categories[baseData.baseCategory]) &&
							categories[baseData.baseCategory].map((subCategory) => (
								<MenuItem key={subCategory} value={subCategory}>
									{subCategory}
								</MenuItem>
							))}
					</Select>
				</Grid>
				<Grid item xs={12} className={classes.modalContentItem}>
					<CheckBoxInput
						label="Upload Muted Videos"
						disabled={false}
						defaultChecked={false}
						isObjectEditor={false}
						directValue={baseData.uploadMuted}
						updateDirectValue={(val) => {
							setBaseData((data) => ({ ...data, uploadMuted: !data.uploadMuted }));
						}}
						style={{ width: '100%', marginLeft: '0' }}
					/>
				</Grid>
				<Grid item xs={12} className={classes.modalContentItem}>
					<FileInput
						label="Upload Video"
						error={{ message: '' }}
						onChange={(files) => {
							setBaseData((baseData) => ({ ...baseData, files }));
						}}
						allowMultipleFiles={true}
					/>
				</Grid>
				<Grid
					xs={12}
					item
					className={classes.modalContentItem}
					style={{ display: 'flex', justifyContent: 'center' }}
				>
					{/* <Button variant="contained" onClick={handleCreateVideo}>
	  Create
	</Button> */}
					<LoadingButton
						size="large"
						type="submit"
						variant="contained"
						loading={videoUploadsOngoing}
						onClick={handleUploadVideos}
					>
						Create
					</LoadingButton>
				</Grid>
			</Grid>
		</>
	);
};

export default UploadMultipleVideos;
